import { SEOUL_TZ } from '@platform/datetime';
import type { EventPost } from '../types/board.type.ts';

const KOREAN_DATE = new Intl.DateTimeFormat('ko-KR', {
  timeZone: SEOUL_TZ,
  year: 'numeric',
  month: '2-digit',
  day: '2-digit',
});

const KOREAN_DATETIME = new Intl.DateTimeFormat('ko-KR', {
  timeZone: SEOUL_TZ,
  year: 'numeric',
  month: '2-digit',
  day: '2-digit',
  hour: '2-digit',
  minute: '2-digit',
});

/** '2026.01.03' 형식 */
export const formatBoardDate = (iso: string): string => {
  const date = new Date(iso);
  const parts = KOREAN_DATE.formatToParts(date);
  const y = parts.find((p) => p.type === 'year')?.value ?? '';
  const m = parts.find((p) => p.type === 'month')?.value ?? '';
  const d = parts.find((p) => p.type === 'day')?.value ?? '';
  return `${y}.${m}.${d}`;
};

/** '2026.02.01 10:00' */
export const formatBoardDateTime = (iso: string): string => {
  return KOREAN_DATETIME.format(new Date(iso)).replace(/\. /g, '.').replace(/\.$/, '');
};

/** '2026.02.01 — 2026.05.31' */
export const formatPeriod = (start: string, end: string): string =>
  `${formatBoardDate(start)} — ${formatBoardDate(end)}`;

/** event status 가 저장돼있지 않을 때 클라이언트에서 계산 */
export const resolveEventStatus = (event: EventPost): NonNullable<EventPost['status']> => {
  if (event.status) return event.status;
  const now = Date.now();
  const start = new Date(event.startsAt).getTime();
  const end = new Date(event.endsAt).getTime();
  if (now < start) return 'UPCOMING';
  if (now > end) return 'ENDED';
  return 'ONGOING';
};

export const EVENT_STATUS_LABEL: Record<NonNullable<EventPost['status']>, string> = {
  UPCOMING: '예정',
  ONGOING: '진행 중',
  ENDED: '종료',
};

export const EVENT_STATUS_CLASS: Record<NonNullable<EventPost['status']>, string> = {
  UPCOMING: 'bg-amber-500/10 text-amber-700 border border-amber-500/30',
  ONGOING: 'bg-emerald-500/10 text-emerald-700 border border-emerald-500/30',
  ENDED: 'bg-neutral-950/[0.04] text-neutral-950/50 border border-black/[0.08]',
};

/** bytes → '1.2 MB' 형식. 첨부 파일 크기 표시용 */
export const formatFileSize = (bytes: number): string => {
  if (bytes < 1024) return `${bytes} B`;
  const units = ['KB', 'MB', 'GB'];
  let size = bytes / 1024;
  let unitIndex = 0;
  while (size >= 1024 && unitIndex < units.length - 1) {
    size /= 1024;
    unitIndex += 1;
  }
  return `${size.toFixed(size >= 10 || unitIndex === 0 ? 0 : 1)} ${units[unitIndex]}`;
};
